export default {"src":"/_next/static/media/SharedWithMe.415edfdd.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};